import api from './api';
import { API_COMMANDS } from './commands';

const registrationIndividual = async (fullName, email, phone) => {
  const response = await api.post(
    '',
    {
      type: 'individual',
      full_name: fullName,
      email,
      phone,
    },
    {
      params: { command: API_COMMANDS.REGISTRATION },
    }
  );
  return response.data;
};

const registrationLegalEntity = async (data) => {
  const response = await api.post(
    '',
    {
      type: 'legal_entity',
      company_name: data.companyName,
      inn: data.inn,
      kpp: data.kpp,
      legal_address: data.legalAddress,
      postal_address: data.postalAddress,
      phone: data.phone,
      full_name: data.fullName,
      email: data.email,
      bank_name: data.bankName,
      bik: data.bik,
      account_number: data.accountNumber,
      correspondent_account: data.correspondentAccount,
    },
    {
      params: { command: API_COMMANDS.REGISTRATION },
    }
  );
  return response.data;
};

export { registrationIndividual, registrationLegalEntity };
